import { LOGIN, LOGOUT } from "./actions";

const initialState = {};
const configOne = {
  pageType: "apply",
  pageTitle: "Check Your Rate",
  homePageURL: "/patientsolutions/",
};
const configTwo = {
  realm: "LCPS",
  copyrightEndYear: new Date().getFullYear(),
};

const reducer = function (state = initialState, action) {
  action.type = "something";
  switch (action.type) {
    case LOGIN:
      return {
        name: action.payload,
      };
    case LOGOUT:
      return {
        name: "",
      };
    default:
      state.siteInfo = this
        ? { ...this, ...configOne }
        : { ...configOne, ...configTwo };
      return state;
  }
};

export { reducer };

